<template>
  <div id="serviceCenterRoot">
    <div id="serviceCenterTitleDiv"
      :style="{ 'color': $store.state.pageTitleColor, 'font-size': $store.state.titleFontSize }">客服中心
      <img style="width:25px;height:25px;position:absolute;right:5px" src="~assets/img/payCenter/close.png"
        @click="pageClose()" />
    </div>
    <div id="iframeBox" style="position: absolute;top:50px;" :style="{ width: width, height: height }">
      <iframe width="100%" height="100%" frameborder="0" scrolling="no" id="myiframe"></iframe>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    url: "",
  },
  data() {
    return {
      // 590px   625px
      height: "90vh",
      width: "100vw",
      loadUrl: false,
      iframe: null,
    }
  },
  mounted: function () {
    // if (this.loadUrl) {
    //   let timer = setTimeout(()=>{
    //   this.$nextTick(() =>{
    //     // this.height = document.documentElement.clientHeight
    //     // // this.height = "90vh"
    //     // this.width = document.documentElement.clientWidth
    //     // ysf-client
    //     let client = document.getElementById('ysf-client')
    //     console.log(client.children);


    //   })
    // }, 300)
    // this.$once('hook:beforeDestory', ()=>{
    //   clearInterval(timer)
    //   timer = null
    // })
    // }

  },
  watch: {
    // url: {
    //   handler(newValue, oldValue) {
    //     if (newValue.length > 0) {
    //       let myiframe = document.getElementById('myiframe')
    //       myiframe.src = newValue
    //     }
    //   }
    // }
    // url: {
    //   handler(newValue, oldValue) {
    //     let iframeBox = document.getElementById('iframeBox')
    //     if (newValue.length > 0) {
    //       this.iframe = document.createElement('iframe')
    //       this.iframe.onload = () => {
    //         console.log('加载完成') // 这样每次都会触发
    //         // console.log(document);
    //         // console.log(document.document);
    //         // let client = document.getElementById('ysf-client')
    //         // console.log(client.children);
    //         // this.iframe.height =  this.iframe.contentWindow.document.documentElement.scrollHeight;
    //       }
    //       this.iframe.src = newValue
    //       this.iframe.width = "100%"
    //       this.iframe.height = "100%"
    //       this.iframe.frameBorder = 0
    //       this.iframe.scrolling = "no"
    //       iframeBox.appendChild(this.iframe)
    //     }else{
    //       if (this.iframe) {
    //         iframeBox.removeChild(this.iframe)
    //       }
    //     }
    //   }
    // }

  },
  methods: {
    pageClose() {
      this.$emit('servicecenterclose')
    },
  },
}
</script>

<style>
body {
  padding-top: 0%;
  margin: 0%;
}

#serviceCenterRoot {
  z-index: 1188;
  width: 100vw;
  height: 100vh;
  /* background-color: transparent; */
  background-color: white;
  position: absolute;
  top: 0%;
  left: 0%;
  display: flex;
  justify-content: center;
}

#serviceCenterContent {
  background-color: white;
  border-radius: 10px;
  /* padding-top: 10px; */
  display: flex;
  flex-direction: column;
  align-items: center;
}

#serviceCenterTitleDiv {
  position: relative;
  top: 0%;
  /* background-color: yellow; */
  width: 100%;
  height: 50px;
  padding-top: 5px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/serviceCenter/ServiceCenter.vue